export default __webpack_public_path__ + "static/media/institution_icon.a9cf3ce4.svg";